export const bodyCodingBenefits = {
    heading: "Benefits of Body Coding",
    content: [
        'Clears trapped emotions and energetic blockages',
        'Restores balance to the body\'s energy systems',
        'Identifies and corrects misalignments in the body\'s circuits and systems',
        'Identifies and releases trapped energies caused by past trauma',
        'Reveals nutritional and energetic deficiencies',
        'Attracts love, abundance, and vitality',
        'Helps release limiting beliefs and negative patterns',
        'Reveals trapped toxins and pathogens',
    ],
}